import {Injectable} from '@angular/core';
import {HttpHelperService} from '@comm-apps/http';
import {Observable} from 'rxjs';
import {UserRequestData, CodeData, CARUser} from '../core/classes/data-types';
import { CodeMappingService } from './code-mapping.service';
import { Roles } from '../models/roles.enum';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AccessRequestService {

  private publicEndpoint: string = 'public-api/access-request';
  private endpoint: string = 'api/access-request';

  constructor(private apiHelper: HttpHelperService, private codeMappingService: CodeMappingService) {
  }

  public findAll(): Observable<UserRequestData[]> {
    return this.apiHelper.request<UserRequestData[]>(`${ this.endpoint }/all` );
  }

  public findDashboard(): Observable<UserRequestData[]> {
    return this.apiHelper.request<UserRequestData[]>(`${ this.endpoint }/dashboard` );
  }

  public save( data: UserRequestData) : Observable<UserRequestData> {
    return this.apiHelper.request<UserRequestData>(`${ this.endpoint }`, { body: data } );
  }

  public savePublic( data: UserRequestData) : Observable<UserRequestData> {
    return this.apiHelper.request<UserRequestData>(`${ this.publicEndpoint }`, { body: data } );
  }

  public nextWorkflow( data: UserRequestData) : Observable<UserRequestData> {
    return this.apiHelper.request<UserRequestData>(`${ this.endpoint }/next-workflow`, { body: data } );
  }

  public prevWorkflow( data: UserRequestData) : Observable<UserRequestData> {
    return this.apiHelper.request<UserRequestData>(`${ this.endpoint }/prev-workflow`, { body: data } );
  }

  public delete( data: UserRequestData) : Observable<UserRequestData> {
    return this.apiHelper.request<UserRequestData>(`${ this.endpoint }/${data.id}`, {method: 'DELETE'});
  }

  public reject( data: UserRequestData) : Observable<UserRequestData> {
    return this.apiHelper.request<UserRequestData>(`${ this.endpoint }/reject`, { body: data } );
  }

  hasEditPrivileges(request: UserRequestData, user: CARUser): boolean {
    if (!(request && user)) return false;

    const newReq = request.statusCd === 'new';
    const approver = this.hasApprovePrivileges(request, user);
    const admin = user.roles.includes('UA_CAR_ADMIN');
    return newReq && (approver || admin);
  }

  hasApprovePrivileges(request: UserRequestData, user: CARUser): boolean {
    if (!(request && user)) return false;

    const lookForRole = 'UA_CAR_' + request.applicationCd + '_APPROVER';
    const approverForApp = user.roles.includes(lookForRole);
    return approverForApp;
  }

  hasBackflowPrivileges(request: UserRequestData, user: CARUser): boolean {
    if (!user) return false;

    const admin = user.roles.includes('UA_CAR_ADMIN');
    return admin;
  }
}
